import React, { useEffect, useState } from 'react';
import { Box, Typography, Divider } from '@mui/material';
import { orderService } from '../../services/orderService';
import { useLocation } from "react-router-dom"

const OrderDetailsPage = () => {
  const location = useLocation()

  const [orderData, setOrderData] = useState(null)
  const pathname = location.pathname
  const unique_string = pathname.substring(pathname.lastIndexOf("/") + 1)


  useEffect(() => {
    const fetchOrderDetails = async () => {
      try {
        const response = await orderService.orderDetail(unique_string)
        console.log("Order Details =>", response)
        setOrderData(response)
      } catch (error) {
        console.error("Error on getting Order Detail Data =>", error)
      }
    }

    fetchOrderDetails()
  }, [])


  // const calculateSubtotal = () => {
  //   return orderData.items.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  // };

  // const calculateTotal = () => {
  //   const subtotal = calculateSubtotal();
  //   const gstAmount = (subtotal * orderData.gst) / 100;
  //   return subtotal + gstAmount + orderData.deliveryCharge - orderData.discount;
  // };

  // const subtotal = calculateSubtotal();
  // const gstAmount = (subtotal * orderData.gst) / 100;
  // const total = calculateTotal();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: '#f5f7fa',
        py: { xs: 2, sm: 4 },
        px: { xs: 2, sm: 3 }
      }}
    >
      <Box
        sx={{
          maxWidth: '800px',
          margin: '0 auto',
          bgcolor: 'white',
          borderRadius: '16px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
          overflow: 'hidden'
        }}
      >
        {/* Header */}
        <Box
          sx={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            p: { xs: 3, sm: 4 },
            textAlign: 'center'
          }}
        >
          {/* Logo */}
          <Box
            sx={{
              width: { xs: '80px', sm: '100px' },
              height: { xs: '80px', sm: '100px' },
              bgcolor: 'white',
              borderRadius: '50%',
              margin: '0 auto',
              mb: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
            }}
          >
            <Box component="img" src={orderData?.logo_url} />
            {/* <Typography
              sx={{
                fontSize: { xs: '32px', sm: '40px' },
                fontWeight: 700,
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}
            >
              SG
            </Typography> */}
          </Box>

          <Typography
            sx={{
              fontSize: { xs: '24px', sm: '32px' },
              fontWeight: 700,
              mb: 1
            }}
          >
            Order Details
          </Typography>
          <Typography sx={{ fontSize: { xs: '14px', sm: '16px' }, opacity: 0.9 }}>
            {/* {orderData.outletName} */}
          </Typography>
        </Box>

        <Box sx={{ p: { xs: 3, sm: 4 } }}>
          {/* Token & Order Type Banner */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              gap: 2,
              mb: 3
            }}
          >
            <Box
              sx={{
                flex: 1,
                bgcolor: '#f0f4ff',
                p: 2,
                borderRadius: '12px',
                border: '2px solid #667eea'
              }}
            >
              <Typography sx={{ fontSize: '12px', color: '#666', mb: 0.5 }}>
                Token Number
              </Typography>
              <Typography sx={{ fontSize: '20px', fontWeight: 700, color: '#667eea' }}>
                {orderData?.order_number}
              </Typography>
            </Box>
            <Box
              sx={{
                flex: 1,
                bgcolor: '#fff5f0',
                p: 2,
                borderRadius: '12px',
                border: '2px solid #ff8c42'
              }}
            >
              <Typography sx={{ fontSize: '12px', color: '#666', mb: 0.5 }}>
                Order Type
              </Typography>
              <Typography sx={{ fontSize: '20px', fontWeight: 700, color: '#ff8c42' }}>
                {orderData?.order_type.toUpperCase()}

              </Typography>
            </Box>
          </Box>

          {/* Customer Details */}
          <Box sx={{ mb: 3 }}>
            <Typography
              sx={{
                fontSize: { xs: '16px', sm: '18px' },
                fontWeight: 600,
                mb: 2,
                color: '#333'
              }}
            >
              Customer Details
            </Typography>
            <Box sx={{ bgcolor: '#fafbfc', p: 2, borderRadius: '12px' }}>
              <Box sx={{ mb: 1.5 }}>
                <Typography sx={{ fontSize: '13px', color: '#666' }}>Name</Typography>
                <Typography sx={{ fontSize: '15px', fontWeight: 500 }}>
                  {orderData?.customer_name}
                </Typography>
              </Box>
              <Box sx={{ mb: 1.5 }}>
                <Typography sx={{ fontSize: '13px', color: '#666' }}>Address</Typography>
                <Typography sx={{ fontSize: '15px', fontWeight: 500 }}>
                  {orderData?.delivery_address}
                </Typography>
              </Box>
              <Box>
                <Typography sx={{ fontSize: '13px', color: '#666' }}>Order Date</Typography>
                <Typography sx={{ fontSize: '15px', fontWeight: 500 }}>
                  {/* {orderData?.ordered_at} */}
                {orderData?.ordered_at && new Date(orderData.ordered_at).toLocaleString()}
                </Typography>
              </Box>
            </Box>
          </Box>

          <Divider sx={{ my: 3 }} />

          {/* Order Items */}
          {orderData?.items && 
          <Box sx={{ mb: 3 }}>
            <Typography
              sx={{
                fontSize: { xs: '16px', sm: '18px' },
                fontWeight: 600,
                mb: 2,
                color: '#333'
              }}
            >
              Order Items
            </Typography>
            {orderData.items.map((item, index) => (
              <Box
                key={item.menu_item_id}
                sx={{
                  mb: 2,
                  pb: 2,
                  borderBottom: index !== orderData.items.length - 1 ? '1px solid #f0f0f0' : 'none'
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                    mb: 1
                  }}
                >
                  <Box sx={{ flex: 1 }}>
                    <Typography sx={{ fontSize: '15px', fontWeight: 600, mb: 0.5 }}>
                      {item.name}
                    </Typography>
                    <Typography sx={{ fontSize: '13px', color: '#666' }}>
                      Qty: {item.quantity} × S${item.total_price}
                    </Typography>
                    {item.addons.length > 0 && (
                      <Box sx={{ mt: 0.5 }}>
                        {item.addons.map((addon, idx) => (
                          <Typography
                            key={idx}
                            component="span"
                            sx={{
                              fontSize: '12px',
                              color: '#667eea',
                              bgcolor: '#f0f4ff',
                              display: 'inline-block',
                              px: 1,
                              py: 0.3,
                              borderRadius: '6px',
                              mr: 0.5,
                              mt: 0.5
                            }}
                          >
                            + {addon}
                          </Typography>
                        ))}
                      </Box>
                    )}
                  </Box>
                  <Typography sx={{ fontSize: '16px', fontWeight: 700, color: '#333' }}>
                    $${item.total_price * item.quantity}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
          }

          <Divider sx={{ my: 3 }} />

          {/* Price Breakdown */}
          <Box sx={{ mb: 3 }}>
            {/* <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1.5 }}>
              <Typography sx={{ fontSize: '15px', color: '#666' }}>Subtotal</Typography>
              <Typography sx={{ fontSize: '15px', fontWeight: 500 }}>₹50</Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1.5 }}>
              <Typography sx={{ fontSize: '15px', color: '#666' }}>
                GST ({orderData.gst}%)
              </Typography>
              <Typography sx={{ fontSize: '15px', fontWeight: 500 }}>
                ₹{gstAmount.toFixed(2)}
                545
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1.5 }}>
              <Typography sx={{ fontSize: '15px', color: '#666' }}>Delivery Charge</Typography>
              <Typography sx={{ fontSize: '15px', fontWeight: 500 }}>
                ₹{orderData.deliveryCharge}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
              <Typography sx={{ fontSize: '15px', color: '#22c55e' }}>Discount</Typography>
              <Typography sx={{ fontSize: '15px', fontWeight: 500, color: '#22c55e' }}>
                -₹{orderData.discount}
              </Typography>
            </Box> */}

            {/* <Divider sx={{ my: 2 }} /> */}

            {/* Total */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                bgcolor: '#667eea',
                p: 2,
                borderRadius: '12px',
                alignItems: 'center'
              }}
            >
              <Typography sx={{ fontSize: '18px', fontWeight: 700, color: 'white' }}>
                Total Amount
              </Typography>
              <Typography sx={{ fontSize: '24px', fontWeight: 700, color: 'white' }}>
                {/* ₹{total.toFixed(2} */}
                S$ 50
              </Typography>
            </Box>
          </Box>

          {/* Footer */}
          <Box
            sx={{
              textAlign: 'center',
              pt: 2,
              borderTop: '2px dashed #e5e7eb'
            }}
          >
            <Typography sx={{ fontSize: '14px', color: '#666', mb: 1 }}>
              Thank you for your order!
            </Typography>
            <Typography sx={{ fontSize: '12px', color: '#999' }}>
              For queries, contact: +91 98765 43210
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default OrderDetailsPage;